import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { toPng } from "html-to-image";
import { useRef } from "react";
import { FaChartLine, FaFire, FaLeaf } from "react-icons/fa";
import "../style/components-style/CarbonImpactSummary.css";
import muiSytle from "../style/components-style/muiStyle";

const CarbonImpactSummary = ({ selectedRow }) => {
  const totalBiogenic = (selectedRow?.biogenic_gwp || 0).toFixed(2);
  const NetImpact = (selectedRow?.gwp_total || 0).toFixed(2);
  const totalFossil = (NetImpact - totalBiogenic).toFixed(2);
  const ref = useRef(null);

  // Determine impact level and styles based on NetImpact
  const getImpactLevel = (impact) => {
    const value = parseFloat(impact);
    if (value <= 10)
      return {
        level: "Low Impact",
        color: "#15a448",
        bgColor: "#f0fdf4",
        progress: 30,
      };
    if (value <= 50)
      return {
        level: "Medium Impact",
        color: "#b45309",
        bgColor: "#fffbeb",
        progress: 60,
      };
    return {
      level: "High Impact",
      color: "#dc2626",
      bgColor: "#fef2f2",
      progress: 90,
    };
  };

  const impactData = getImpactLevel(NetImpact);
  const download = (ref, filename) => {
    if (ref.current) {
      toPng(ref.current)
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = filename;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };
  return (
    <Accordion elevation={0} ref={ref}>
      <AccordionSummary>
        <Typography variant="Accordion Summary">Carbon Impact Summary</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className="carbon-impact-grid-container">
          <div className="carbon-impact-grid">
            {/* Biogenic CO2 Card */}
            <div className="carbon-impact-card">
              <div className="carbon-impact-card-header green">
                <FaLeaf size={20} style={{ color: "#059669" }} />
                <span className="carbon-impact-card-header-text">
                  Total Biogenic CO<sub>2</sub>
                </span>
              </div>
              <h2 className="carbon-impact-value"> {totalBiogenic}</h2>
              <p className="carbon-impact-unit">
                kg CO<sub>2</sub>e / unit
              </p>
            </div>

            {/* Fossil CO2 Card */}
            <div className="carbon-impact-card">
              <div className="carbon-impact-card-header gray">
                <FaChartLine size={20} style={{ color: "#4b5563" }} />
                <span className="carbon-impact-card-header-text">
                  Total Fossil CO<sub>2</sub>
                </span>
              </div>
              <h2 className="carbon-impact-value">{totalFossil}</h2>
              <p className="carbon-impact-unit">
                kg CO<sub>2</sub>e / unit
              </p>
            </div>

            {/* Net Carbon Impact Card */}
            <div className="carbon-impact-card" style={{ backgroundColor: impactData.bgColor }}>
              <div className="carbon-impact-header-container">
                <div className="carbon-impact-card-header" style={{ color: impactData.color }}>
                  <FaFire size={20} style={{ color: impactData.color }} />
                  <span className="carbon-impact-card-header-text">Net Carbon Impact</span>
                </div>
                <div className="carbon-impact-impact-level" style={{ color: impactData.color }}>
                  <span>{impactData.level}</span>
                </div>
              </div>
              <h2 className="carbon-impact-value" style={{ color: impactData.color }}>
                {NetImpact}
              </h2>
              <p className="carbon-impact-unit">
                kg CO<sub>2</sub>e / unit
              </p>
              <div className="carbon-impact-progress-bar">
                <div
                  className="carbon-impact-progress-value"
                  style={{
                    backgroundColor: impactData.color,
                    width: `${impactData.progress}%`,
                  }}></div>
              </div>
            </div>
          </div>

          <div className="carbon-impact-footer">
            <p className="carbon-impact-last-updated">Last updated: 3/13/2025</p>
            <div className="carbon-impact-actions">
              <button
                className="carbon-impact-button outline"
                onClick={() => {
                  download(ref, "Carbon_Impact_Summary");
                }}>
                Download Data
              </button>
              <button className="carbon-impact-button primary">Generate Report</button>
            </div>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default CarbonImpactSummary;
